import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../app/store";
import Avatar from "../../../assets/images/avatar.svg";
import { useSocket } from "../../../contexts/SocketContext";
import { GetSingleEmployee } from "../../../types";

export default function Person({
  employee,
  handleClose,
}: {
  employee: GetSingleEmployee;
  handleClose: () => void;
}) {
  const navigate = useNavigate();
  const { socket } = useSocket();
  const auth = useAppSelector((state) => state.auth);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isCalledRef = useRef(false);
  let basePath = "/user/communication/message/";
  if (auth?.role === "super_admin" || auth?.role === "Admin") {
    basePath = "/admin/communication/message/";
  }

  const openConversation = () => {
    if (isCalledRef.current) return;
    isCalledRef.current = true;
    socket?.off("one-to-one-connected");

    socket?.emit("connect_users", {
      user1Id: auth.user?.id,
      user2Id: employee.id,
    });

    const listener = (payload: any) => {
      navigate(basePath + employee.id + "?chatId=" + payload.chatId);
      socket?.off("one-to-one-connected", listener);
      isCalledRef.current = false;
    };

    socket?.once("one-to-one-connected", listener);

    handleClose();

    timeoutRef.current = setTimeout(() => {
      isCalledRef.current = false;
    }, 500);
  };

  return (
    <div
      className="flex items-center justify-between mb-2 cursor-pointer"
      onClick={openConversation}
    >
      <div className="flex gap-4 items-center">
        <div>
          <img
            src={employee?.personalInfo?.pro_pic || Avatar}
            alt=""
            className="w-10 h-10 rounded-full"
          />
        </div>
        <div className="text-[17px]">{employee?.officialInfo?.name}</div>
      </div>
    </div>
  );
}
// const navigate = useNavigate();
//   const { socket } = useSocket();
//   const auth = useAppSelector((state) => state.auth);
//   const timeoutRef = useRef<NodeJS.Timeout | null>(null);
//   const isCalledRef = useRef(false);

//   const openConversation = () => {
//     if (isCalledRef.current) return;
//     isCalledRef.current = true;

//     socket?.emit("connect_users", {
//       user1Id: auth.user?.id,
//       user2Id: employee.id,
//     });

//     socket?.once("one-to-one-connected", (payload: any) => {
//       navigate(
//         "/admin/communication/message/" +
//           employee.id +
//           "?chatId=" +
//           payload.chatId,
//       );
//     });

//     handleClose();

//     timeoutRef.current = setTimeout(() => {
//       isCalledRef.current = false;
//     }, 500);
//   };
